import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Zone } from '../../../_models/zone.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-zone-modal',
  templateUrl: './edit-zone-modal.component.html',
  styleUrls: ['./edit-zone-modal.component.scss']
})
export class EditZoneModalComponent implements OnInit {
  @Input() id: number;
  public Id;
  formGroup: FormGroup;
  zone: Zone;

  constructor(public modal: NgbActiveModal) { } 

  ngOnInit(): void 
  {
    this.loadCountry();
  }

  loadCountry() 
  {
    if(!this.id)
    {    
      // console.log("called inside load country");  
      // this.country = EMPTY_COUNTRY;
      this.loadForm();
    }    
    else
    {
      // console.log("called inside load country else");
      // this.country = {
      //   id: 1,
      //   countryId: 1,
      //   country_Name: 'INDIA',
      //   country_Code: '',
      //   currency: '',
      //   isD_Code: '',
      //   pin_code_Length: '',
      //   status: undefined,
      //   isActive: undefined,
      //   created_at: '',
      //   userId: undefined
      // };
      // const sb = this.countryService.getItemById(this.id).pipe( 
      //   first(),
      //   catchError((errorMessage) => {
      //     this.modal.dismiss(errorMessage);
      //     return of(EMPTY_COUNTRY);
      //   })
      // ).subscribe((country: Country) => {
      //   this.country = country;
      //   this.loadForm();
      // });
      // this.subscriptions.push(sb);
      // this.country.countryId = this.id;      
      this.Id = this.id;
      // console.log("id is "+this.id);
      this.loadForm();
    }
  }

  loadForm()
  {
     this.formGroup = new FormGroup({
      countryName     :   new FormControl('',Validators.required),
      zoneName     :   new FormControl('',Validators.required)
    });
  }
  save() {console.log(this.formGroup.value);}

  // helpers for View
  isControlValid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError(validation, controlName): boolean {
    const control = this.formGroup.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(controlName): boolean {
    const control = this.formGroup.controls[controlName];
    return control.dirty || control.touched;
  }

}
